export default "__VITE_ASSET__BlZI4fyc__"